<template>
  <div>
    <router-view />
  </div>
</template>
  
  <script type="text/javascript">
import { mapActions } from "vuex";

export default {
  data() {
    return {
      drawer: true,
    };
  },
  components: {},
  methods: {
    ...mapActions({
      logOut: "auth/logOut",
    }),
    async logout() {
      await this.logOut();
      localStorage.removeItem('token');
      window.location.href = '/';
    },
  },
};
</script>
  